
import './App.css';
import Navbar from './components/Navbar/Navbar'
import Main from './components/Main/Main'
import Footer from './components/Footer/Footer'

function App() {
  return (
<>
  <Navbar/>
  <Main/>
  <Footer/>
 
</>
  );
}

export default App;
